import { Checkbox, FormControlLabel, Grid2 } from "@mui/material";
import { Moment } from "moment";
import { FC, useEffect, useState } from "react";
import {
	EndFilter,
	StartFilter,
} from "../../../shared/components/StartEndFilter";
import { DelayAreaSelector } from "@/shared/selectors/DelayAreaSelector";

type Props = {
	onFilterChange: (startDate: Moment, endDate: Moment) => void;
	initialStartDate: Moment;
	initialEndDate: Moment;
	selectedDelayArea: number | null;
	onDelayAreaChange: (assetId: number | null) => void;
	includeMicrodelays: boolean;
	onIncludeMicrodelaysChange: (include: boolean) => void;
	includeUndeclaredDelays: boolean;
	onIncludeUndeclaredDelaysChange: (include: boolean) => void;
	includeRollChange: boolean;
	onIncludeRollChangeChange: (include: boolean) => void;
};

export const Filters: FC<Props> = ({
	onFilterChange,
	initialStartDate,
	initialEndDate,
	selectedDelayArea,
	onDelayAreaChange,
	includeMicrodelays,
	onIncludeMicrodelaysChange,
	includeUndeclaredDelays,
	onIncludeUndeclaredDelaysChange,
	includeRollChange,
	onIncludeRollChangeChange,
}) => {
	const [startDate, setStartDate] = useState<Moment>(initialStartDate);
	const [endDate, setEndDate] = useState<Moment>(initialEndDate);

	useEffect(() => {
		setStartDate(initialStartDate);
		setEndDate(initialEndDate);
	}, [initialStartDate, initialEndDate]);

	const handleStartDateChange = (date: Moment | null) => {
		if (date) {
			setStartDate(date);
			onFilterChange(date, endDate);
		}
	};

	const handleEndDateChange = (date: Moment | null) => {
		if (date) {
			setEndDate(date);
			onFilterChange(startDate, date);
		}
	};

	return (
		<Grid2 container alignItems="center" spacing={2}>
			<Grid2 size={{ xs: 12, md: 1.5 }}>
				<StartFilter value={startDate} onChange={handleStartDateChange} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: 1.5 }}>
				<EndFilter value={endDate} onChange={handleEndDateChange} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: 1.5 }}>
				<DelayAreaSelector
					value={selectedDelayArea}
					onChange={onDelayAreaChange}
					isFiltering
				/>
			</Grid2>
			<Grid2 size={{ xs: 12, md: 1 }}>
				<FormControlLabel
					control={
						<Checkbox
							checked={includeMicrodelays}
							color="primary"
							onChange={(e) => onIncludeMicrodelaysChange(e.target.checked)}
						/>
					}
					label="Microdelays"
				/>
			</Grid2>
			<Grid2 size={{ xs: 12, md: 1.5 }}>
				<FormControlLabel
					control={
						<Checkbox
							checked={includeUndeclaredDelays}
							color="primary"
							onChange={(e) =>
								onIncludeUndeclaredDelaysChange(e.target.checked)
							}
						/>
					}
					label="Undeclared Delays"
				/>
			</Grid2>
			<Grid2 size={{ xs: 12, md: 1.5 }}>
				<FormControlLabel
					control={
						<Checkbox
							checked={includeRollChange}
							color="primary"
							onChange={(e) => onIncludeRollChangeChange(e.target.checked)}
						/>
					}
					label="Roll Changes"
				/>
			</Grid2>
		</Grid2>
	);
};
